import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { isFunction } from 'lodash-es';
import { TooltipDirective } from 'shared/directives/tooltip.directive';
import { ColoredIconColorsEnum } from 'shared/enums/colored-icon-colors.enum';
import { ColoredIconTypesEnum } from 'shared/enums/colored-icon-types.enum';

@Component({
    selector: 'app-colored-icon-cell-renderer',
    imports: [CommonModule, TooltipDirective, TranslateModule],
    templateUrl: './colored-icon-cell-renderer.component.html',
    styleUrl: './colored-icon-cell-renderer.component.scss',
})
export class ColoredIconCellRendererComponent implements ICellRendererAngularComp {
    public ColoredIconTypesEnum = ColoredIconTypesEnum;

    protected iconType!: ColoredIconTypesEnum;
    protected iconColor!: ColoredIconColorsEnum;
    protected tooltipText!: string | null;

    agInit(
        params: ICellRendererParams & {
            iconType: Function;
            iconColor: Function;
            tooltipText?: string | Function;
        },
    ): void {
        if (isFunction(params.tooltipText)) {
            this.tooltipText = params.tooltipText?.call(this, params.value);
        } else {
            this.tooltipText = params.tooltipText?.toString() ?? null;
        }
        this.iconColor = params.iconColor?.call(this, params.value) ?? (ColoredIconColorsEnum.NEUTRAL as ColoredIconColorsEnum);
        this.iconType = params.iconType?.call(this, params.value) ?? (ColoredIconTypesEnum.UNKNOWN as ColoredIconTypesEnum);
    }

    refresh(): boolean {
        return false;
    }
}
